import { Badge, Group, Text } from '@mantine/core'

type FormLabelProps = {
  title: string
  require: boolean
  description?: string
}

export const FormLabel = ({ title, require, description }: FormLabelProps) => {
  return (
    <Group>
      <Text fw='bold'>{title}</Text>
      {require && (
        <Badge color='error' variant='filled' radius='sm'>
          必須
        </Badge>
      )}
      {description && <Text size='sm'>{description}</Text>}
    </Group>
  )
}
